<template>
  <div class="logout">
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: "logout",
  data: () => ({}),
  created: function() {
    this.logout();
    //clearInterval();
  },
  methods: {
    logout: function() {
      
      var self=this;
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API+"/v1/operator/logout",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(res) {self.$config.loading=false;
          
          console.log(res);
          if ( res.status == "success") {
            self.$router.push("/v1/operator/login");
          }
          console.log("logout success");
          
        },
        error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
          
          //if session expired
         if(textstatus==="timeout") {
            alert("Request timeout");
        } else if ( jqXHR.responseJSON.code == 401 ) {
            self.$router.push(
              "/v1/operator/login"
            )  
          } else if ( jqXHR.responseJSON.code == 400 ) {
            alert(jqXHR.responseJSON.message);
          }
            
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#loginroute {
  color: #2c3e50;
}

.hello {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/logout.vue